/**
 * バリデーションエラーの各メッセージ種別
 */
export const VALIDATION_MESSAGE_TYPES = {
  /**
   * テキスト入力必須エラー
   */
  INPUT_REQUIRED: '入力してください',

  /**
   * 選択必須エラー
   */
  SELECT_REQUIRED: '選択してください',

  /**
   * 選択必須エラー（複数）
   */
  MULTI_SELECT_REQUIRED: '1つ以上選択してください',

  /**
   * Email 入力形式エラー
   */
  INVALID_EMAIL: '正しいメールアドレスを入力してください',

  /**
   * メールドメインエラー
   */
  INVALID_MAIL_DOMAIN: 'フリーメール、プロバイダーメール、モバイルキャリアメールはご利用いただけません',

  /**
   * URL 入力形式エラー
   */
  INVALID_URL: '正しいURLを入力してください',

  /**
   * パスワード入力形式エラー
   */
  INVALID_PASSWORD: '半角英数記号8文字以上64文字以下で入力してください',

  /**
   * 半角数字入力形式エラー
   */
  INVALID_NUMBER: '半角数字で入力してください',

  /**
   * かな入力形式エラー
   */
  INVALID_KANA: 'ひらがなまたはカタカナで入力してください',

  /**
   * 日付入力形式エラー
   */
  INVALID_DATE: '正しいDateを入力してください',

  /**
   * 電話番号入力形式エラー
   */
  INVALID_PHONE_NUMBER: '半角数字のみで正しい番号を入力してください',

  /**
   * 入力文字の指定文字数範囲外エラー
   */
  OUT_OF_RANGE: '{{ min }}から{{ max }}の範囲で入力してください',

  /**
   * 入力文字最大数エラー
   */
  OVER_MAX_LENGTH: '入力できる最大値を超えています',

  /**
   * 入力文字最小数エラー
   */
  BELOW_MIN_LENGTH: '入力できる最小値に達していません',
} as const

/**
 * 無指定だった場合のデフォルトのバリデーションエラーメッセージ
 */
export const VALIDATION_DEFAULT_MESSAGES = {
  required: '入力してください',
  email: '正しいメールアドレスを入力してください',
  mailDomain: 'フリーメール、プロバイダーメール、モバイルキャリアメールはご利用いただけません',
  url: '正しいURLを入力してください',
  password: '半角英数記号8文字以上64文字以下で入力してください',
  number: '半角数字で入力してください',
  kana: 'ひらがなまたはカタカナで入力してください',
  date: '正しいDateを入力してください',
  phoneNumber: '半角数字のみで正しい番号を入力してください',
  range: '{{ min }}から{{ max }}の範囲で入力してください',
  maxLength: '入力できる最大値を超えています',
  minLength: '入力できる最小値に達していません',
} as const
